import React from 'react';
import ReactEmoji from 'react-emoji';
import { Query } from 'react-apollo';

import styles from './MessageHistory.css';
import { GET_MESSAGES_BETWEEN_USERS } from '../../../../query/queries';
import MessageCard from './message-card';
import HeaderConversation from './header-conversation';


const MessageHistory = ({ props, setScrollRef }) => {
  let initialContainerTheme = '';
  if (props.theme === 'DARK') initialContainerTheme = styles.initialContainerDarkTheme;

  return <div className={styles.mainContainer}>
    {!props.receiver &&
      <div className={[styles.initialContainer, initialContainerTheme].join(' ')}>
        <span>{ReactEmoji.emojify('Bienvenido :) Ahora ya puedes enviar y recibir mensajes de tus amigos.')}</span>
        <label>Haz click en un chat para comenzar</label>
      </div>}

    {props.receiver &&
      <div className={styles.infoContainer}>
        <HeaderConversation user={props.receiver} theme={props.theme} />
        <Query
          query={GET_MESSAGES_BETWEEN_USERS}
          variables={{ from: props.receiver.username, to: props.user.username }}
          pollInterval={400}
        >
          {({ error, loading, data: { allMessages } }) => {
            if (loading) return <div className={[styles.initialContainer, initialContainerTheme].join(' ')}>
              <label>Cargando mensajes...</label>
            </div>
            if (error) return 'OH NO, ERROR!';
            if (allMessages.length === 0) {
              return <div className={[styles.initialContainer, initialContainerTheme].join(' ')}>
                <label>No has intercambiado mensajes aún.</label>
                <label>¡Sé el primero en enviar uno!</label>
              </div>
            }
            return <MessageHistoryList allMessages={allMessages} receiver={props.receiver} />
          }}
        </Query>
      </div>
    }
  </div>
};

class MessageHistoryList extends React.Component {
  componentDidMount() {
    if (this.ref) {
      this.ref.scrollTop = this.ref.scrollHeight;
    }

  }
  componentDidUpdate(prevProps) {
    console.log('entro');
    if (this.ref && this.props.allMessages.length !== prevProps.allMessages.length) {
      this.ref.scrollTop = this.ref.scrollHeight;
    }
  }

  render() {
    return (
      <div className={styles.messageContainer} ref={ref => this.ref = ref}>
        {this.props.allMessages.map((message, index) => {
          let isMine = true;
          if (message.from === this.props.receiver.username) {
            isMine = false;
          }
          let isUrl = false;
          let url = '';
          if (hasHttpOrHttpsUrl(message)) {
            isUrl = true;
            url = getUrlFromMessage(message)
          }
          return <MessageCard message={message.text} isMine={isMine} key={index} isUrl={isUrl} url={url}/>
        })
        }
      </div>
    );
  }
}

const httpOrHttpsRegex = RegExp(/\bhttps?:\/\/\S+/gi);

const hasHttpOrHttpsUrl = (message) => httpOrHttpsRegex.test(message.text);

const getUrlFromMessage = (message) => message.text.match(httpOrHttpsRegex);

export default MessageHistory;


// WEBPACK FOOTER //
// ./src/pages/chat/chat-messages/message-history/MessageHistory.jsx